import React from 'react'

interface IconProps {
  className?: string
  isPlain?: boolean
  isSVG?: boolean
  setIsSVG?: (value: boolean) => void
  value?: string
}

export const CopyIcon: React.FC<IconProps> = ({ className, value, isPlain }) => {
  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value)
    }
  }

  return (
    <button
      className={`p-1 hover:bg-gray-100 rounded ${className}`}
      onClick={handleCopy}
      title="复制代码"
      aria-label="复制代码"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
    </button>
  )
}

export const SvgIcon: React.FC<IconProps> = ({ isSVG, setIsSVG }) => {
  return (
    <button
      className="p-1 hover:bg-gray-100 rounded mr-1"
      onClick={() => setIsSVG?.(!isSVG)}
      title="切换SVG视图"
      aria-label="切换SVG视图"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
    </button>
  )
}

export const FlowIcon: React.FC<{ PrimitiveCode: string }> = ({ PrimitiveCode }) => {
  return (
    <div className="mermaid">
      {PrimitiveCode}
    </div>
  )
} 